<template>
  <div class="group-list-wrap">
    <!-- 引入公共头部 -->
    <dg-header title="拼团购"></dg-header>
    <div class="content">
      <pull-refresh :refreshing="isRefreshing" :on-refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="'没有更多了'"
          :offset="10"
          @load="onLoads"
          class="group-ul"
          v-if="dataList.length > 0">
         
          <li v-for="(item, i) in dataList" :key="i" @click="goDetails(item)">
           
              <div class="time" v-html="times(item.Countdown)"></div>
              <div class="p-img data-no-phott dg-no-photo">
                <img :src="item.comImage[0].url" v-if="item.comImage && item.comImage.length > 0">
              </div>
              <div class="p-name">
                <span class="tag">[团购]</span>{{item.comName}}
              </div>
              <div class="btn-box">
                <span class="price y-price">
                  <i>原 &nbsp;&nbsp; 价： JPY</i>
                  <del>{{item.price | setNumber}}</del>
                </span>
              </div>
              <div class="btn-box">
                <span class="price">
                  <i>拼团价： JPY</i>
                  {{item.groupBuy.groupBuyPrice | setNumber}}
                </span>
              </div>
          </li>
        
        </van-list>
         <div class="dg-no-data" v-if="flag">暂无数据</div>
      </pull-refresh>
    </div>
    <dg-footer></dg-footer>
  </div>
</template>
<script>
import DgFooter from "@/components/footer";
import DgHeader from "@/components/header";
import pullRefresh from "@/components/pullRefresh.vue";
import api from "@/server";
import { clearInterval } from 'timers';
export default {
  data() {
    return {
      dataList: [],
      isRefreshing: false,
      loading: false,
      finished: false,
      flag: false,
      params: {
        pageSize: 6,
        pageNumber: 1
      },
      totalPage: 0,
      timer: null,
    };
  },
  components: {
    DgFooter,
    DgHeader,
    pullRefresh
  },
  activated() {
    this.params.pageNumber = 1;
    this.getGroupList();
  },
 
  methods: {
    // 获取商品列表
    getGroupList(type) {
      api
        .getGroupList(this.params)
        .then(res => {

          // 防止进入页面出去后再进来计时器重复启动
          if (this.timer) {
            window.clearInterval(this.timer);
          }
          let data = res.data.commondityList; 
          if (type === 'scroll') {
            this.dataList = this.dataList.concat(data);
            // console.log(this.dataList)
            this.loading = false;
            this.beginTimer()
          } else {
            if (res.code === 200 && data.length > 0) {
              this.flag = false;
              this.dataList = data;
              this.totalPage = res.data.pageInfo.totalPageNumber;
              this.beginTimer();
            } else {
              this.dataList = [];
              this.flag = true;
            }
          }
          this.isRefreshing  = false;
        }).catch(() => {
          this.flag = true;
          this.isRefreshing = false;    
        });
    },
    beginTimer() {
      let _this = this;
      this.timer = setInterval(() => {
        for (let i = 0, len = _this.dataList.length; i < len; i++) {
          const item = _this.dataList[i];
          if (item.Countdown > 0) {
            item.Countdown = item.Countdown - 1000;
          }
        }
      }, 1000);
    },
    // 跳转详情页
    goDetails(item) {
      if(item.Countdown <= 0) {
        this.$toast("活动已结束，请选择查看其他活动商品！");
        this.getGroupList()
      } else {
        this.$router.push({
          name: 'product-detail',
          query: {
            id: item._id
          }
        })
      }
    },
    // 每秒把时间重新计算下
    times(time) {
      // 这个函数是
      if (time >= 0) {
        let str = "";
        let day = Math.floor(time / 1000 / 60 / 60 / 24);
        let h = Math.floor((time / 1000 / 60 / 60) % 24);
        let m = Math.floor((time / 1000 / 60) % 60);
        let s = Math.floor((time / 1000) % 60);
        h = h < 10 ? "0" + h : h;
        m = m < 10 ? "0" + m : m;
        s = s < 10 ? "0" + s : s;
        str =
         '<span class="time-text">' +
          day +'天'+
          "</span>" +
          '<span class="fh">： </span>' +
          '<span class="time-text">' +
          h +
          "</span>" +
          '<span class="fh">： </span>' +
          '<span class="time-text">' +
          m +
          "</span>" +
          '<span class="fh">： </span>' +
          '<span class="time-text">' +
          s +
          "</span>";

        return str;
      } else {
        return '<span class="time-text">活动已结束</span>';
      }
    },
    // 下拉刷新
    onRefresh() {
      this.isRefreshing = true;   
      this.finished = false;
      this.loading = false;
      this.flag = false;  
      this.params.pageNumber = 1;
      this.getGroupList();
    },
    // 滚动加载
    onLoads() {
      this.params.pageNumber++;
      if (this.params.pageNumber > this.totalPage) {
        this.finished = true;
        this.params.pageNumber--;
      } else {
        this.getGroupList('scroll')
      }
    }
  },
  deactivated() {
    window.clearInterval(this.timer);        
    this.timer = null;
  }
};
</script>
<style lang="scss">
.group-list-wrap {
  .content {
    padding: 88px 30px 98px;
  }
  .group-ul {
    width: calc(100% + 10px);
    height: auto;
    display: flex;
    flex-flow: wrap;
    overflow: hidden;
    margin-top: 15px;
    background: $bg01;
    .van-list__loading{
      display: none;
    }
    .van-list__finished-text{
      width: 100%;
    }
    li {
      flex: 0 0 calc(50% - 10px);
      height: 460px;
      margin-right: 10px;
      margin-top: 10px;
      background: $bg02;
      border-radius: $br30;
      overflow: hidden;
      position: relative;
    }
    .time {
      padding: 5px 10px;
      // background:rgba(255,0,0,0.7);
      position: absolute;
      top: 10px;
      right: 20px;
      color: white;
      border-radius: 5px;
      display: flex;
      .time-text {
        padding: 0 7px;
        min-width: 45px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        display: block;
        background: rgba(255, 0, 0, 0.7);
        border-radius: 5px;
        font-size: 24px;
      }
      .fh {
        width: 5px !important;
        color: rgba(255, 0, 0, 1);
        background: none;
        margin-left: 5px;
        margin-right: 10px;
      }
    }
    .p-img {
      width: 100%;
      height: 310px;
      overflow: hidden;
      img {
        width: 100%;
        height: auto;
        object-fit: cover;
      }
    }
    .p-name {
      width: 100%;
      height: 24px;
      color: $fc03;
      display: block;
      padding: 0 15px;
      line-height: 1;
      margin-top: 20px;
      text-align: left;
      @include ellipsis();
      .tag {
        color: $fc04;
      }
    }
    .btn-box {
      width: 100%;
      // height: 44px;
      // line-height: 44px;
      display: flex;
      padding: 0 15px;
      margin-top: 15px;
      .price {
        // flex: 1;
        font-size: 28px;
        color: $fc04;
        text-align: left;
        line-height: 1;
        i {
          font-style: normal;
          font-size: 22px;
        }
      }
      .y-price {
        color: $fc09;
      }
      .prime {
        padding: 2px 10px;
        height: 22px;
        color: white;
        background: $fc04;
        font-size: 0.2rem;
        position: relative;
        margin-left: 20px;
        // margin-top: 3px;
        border-radius: 3px;
        span {
          width: 0;
          height: 0;
          border-width: 6px 11px 6px 0;
          border-style: solid;
          border-color: transparent $fc04 transparent transparent; /*灰 透明 透明 */
          position: absolute;
          top: 5px;
          left: -10px;
        }
      }
      .group-price {
        font-size: 22px;
        color: $fc04;
        flex: 1;
        line-height: 1;
        i {
          font-style: normal;
          font-size: 22px;
        }
      }
      .buy-btn {
        width: 120px;
        height: 100%;
        border-radius: $br30;
        background: $btn01;
        color: $fc02;
        text-align: center;
        &:active {
          background: $btnHover01;
        }
      }
    }
  }
}
</style>